import React from "react";
import { useTranslation } from "react-i18next";

export type BadgeVariant = "success" | "warning" | "danger" | "info" | "primary" | "secondary";

interface BadgeProps {
  variant: BadgeVariant;
  text: string;
  showIcon?: boolean;
  className?: string;
  translateText?: boolean;
  style?: React.CSSProperties;
}

const Badge: React.FC<BadgeProps> = ({ 
  variant, 
  text, 
  showIcon = true, 
  className = "", 
  translateText = true,
  style
}) => {
  const { t } = useTranslation();
  
  const displayText = translateText ? t(text) : text;
  
  return (
    <span className={`badge badge-soft-${variant} d-inline-flex align-items-center ${className}`} style={style}>
      {showIcon && <i className="ti ti-circle-filled fs-5 me-1" />}
      {displayText}
    </span>
  );
};

export default Badge;
